var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "操作日志",
            "close-on-click-modal": false,
            top: "150px",
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: { option: _vm.options, data: _vm.deviceLog, page: _vm.page },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "refresh-change": _vm.getList,
              "on-load": _vm.getList,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }